import React from 'react';
import { DS } from './ds';
export const GlobalStyles = () => <style data-id="element-63" data-mp="2aq9tbq739wya">{`
    @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Manrope:wght@300;400;500;600;700&display=swap');

    .alinova-root *, .alinova-root *::before, .alinova-root *::after {
      box-sizing: border-box; margin: 0; padding: 0;
    }
    html { scroll-behavior: smooth; }
    .alinova-root {
      background: ${DS.color.ivory};
      -webkit-font-smoothing: antialiased;
      overflow-x: hidden;
      width: 100%;
    }
    .alinova-root img, .alinova-root video { max-width: 100%; display: block; }

    /* ── Accesibilidad: foco visible solo para navegación por teclado ── */
    .alinova-root a:focus,
    .alinova-root button:focus,
    .alinova-root input:focus,
    .alinova-root select:focus,
    .alinova-root textarea:focus,
    .alinova-root [tabindex]:focus {
      outline: none;
    }
    .alinova-root a:focus-visible,
    .alinova-root button:focus-visible,
    .alinova-root input:focus-visible,
    .alinova-root select:focus-visible,
    .alinova-root textarea:focus-visible,
    .alinova-root [tabindex]:focus-visible {
      outline: 2px solid ${DS.color.aqua};
      outline-offset: 2px;
      border-radius: 4px;
    }

    /* ── Motion system ── */
    @keyframes fadeUp {
      from { opacity: 0; transform: translate3d(0, 28px, 0); }
      to   { opacity: 1; transform: translate3d(0, 0, 0); }
    }
    @keyframes fadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
    @keyframes floatY {
      0%, 100% { transform: translateY(0); }
      50%       { transform: translateY(-10px); }
    }
    @keyframes rotateSlow  { from { transform: rotate(0deg);   } to { transform: rotate(360deg);  } }
    @keyframes rotateSlowR { from { transform: rotate(360deg); } to { transform: rotate(0deg);    } }

    @keyframes haloBreath {
      0%, 100% { transform: scale(0.96); opacity: 0.10; }
      50%       { transform: scale(1.06); opacity: 0.28; }
    }
    @keyframes haloBreath2 {
      0%, 100% { transform: scale(1.04); opacity: 0.06; }
      50%       { transform: scale(0.96); opacity: 0.20; }
    }
    @keyframes pulseRing {
      0%       { transform: scale(0.82); opacity: 0.55; }
      80%, 100%{ transform: scale(1.22); opacity: 0;    }
    }
    @keyframes scanLine {
      0%, 100%  { transform: translateY(-120%); opacity: 0;    }
      18%, 72%  {                               opacity: 0.55; }
      84%       { transform: translateY(340%);  opacity: 0;    }
    }
    @keyframes particleF {
      0%, 100% { transform: translate3d(0, 0, 0)    scale(0.92); opacity: 0.3;  }
      50%       { transform: translate3d(0,-12px, 0) scale(1.10); opacity: 0.95; }
    }
    @keyframes lightRay {
      0%, 100% { opacity: 0.06; transform: rotate(-12deg) scaleX(0.92); }
      50%       { opacity: 0.22; transform: rotate(-7deg)  scaleX(1.06); }
    }
    @keyframes cadDraw {
      from { stroke-dashoffset: 520; opacity: 0.12; }
      to   { stroke-dashoffset: 0;   opacity: 0.70; }
    }
    @keyframes blinkDot {
      0%, 100% { opacity: 0.3;  }
      50%       { opacity: 1;    }
    }
    @keyframes glowPulse {
      0%, 100% { box-shadow: 0 0 18px rgba(75,199,210,0.18); }
      50%       { box-shadow: 0 0 38px rgba(75,199,210,0.38); }
    }
    @keyframes gridDrift {
      0%   { background-position: 0 0;     }
      100% { background-position: 52px 52px; }
    }
    @keyframes alignerRotate {
      0%   { transform: rotate(-1.5deg) translateY(0px);   }
      50%  { transform: rotate(1.5deg)  translateY(-8px);  }
      100% { transform: rotate(-1.5deg) translateY(0px);   }
    }
    @keyframes waPulse {
      0% { transform: scale(1); opacity: 0.5; }
      70%, 100% { transform: scale(1.45); opacity: 0; }
    }

    /* ── Utility classes ── */
    .reveal {
      opacity: 0;
      transform: translate3d(0, 24px, 0);
      transition: opacity 700ms ${DS.ease.expo}, transform 700ms ${DS.ease.expo};
    }
    .reveal.is-visible { opacity: 1; transform: translate3d(0, 0, 0); }

    /* ── Entrada por scroll ── */
    .alinova-root section[id] {
      opacity: 0;
      transform: translateY(24px);
      transition:
        opacity 0.65s cubic-bezier(0.16, 1, 0.3, 1),
        transform 0.65s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .alinova-root section[id].section-visible {
      opacity: 1;
      transform: translateY(0);
    }

    .anim-fade-up    { animation: fadeUp       0.7s ${DS.ease.expo} both; }
    .anim-fade-in    { animation: fadeIn        0.5s ${DS.ease.expo} both; }
    .anim-float      { animation: floatY        5s  ease-in-out infinite; }
    .anim-float-r    { animation: floatY        6s  ease-in-out infinite; }
    .anim-rotate     { animation: rotateSlow   28s  linear     infinite; }
    .anim-rotate-r   { animation: rotateSlowR  32s  linear     infinite; }
    .anim-pulse-glow { animation: haloBreath    3s  ease-in-out infinite; }
    .anim-glow-pulse { animation: glowPulse     3s  ease-in-out infinite; }
    .anim-grid-drift { animation: gridDrift    12s  linear     infinite; }
    .anim-aligner    { animation: alignerRotate 7s  ease-in-out infinite; }
    .anim-rotate-cw  { animation: rotateSlow    28s linear infinite; }
    .anim-rotate-ccw { animation: rotateSlowR   32s linear infinite; }

    /* ── Hover helpers ── */
    .hover-lift {
      transition: transform 0.25s ${DS.ease.smooth}, box-shadow 0.25s ${DS.ease.smooth};
    }
    .hover-lift:hover {
      transform: translateY(-4px);
      box-shadow: ${DS.shadow.cardHover};
    }
    .hover-glow:hover {
      box-shadow: ${DS.shadow.glow};
    }

    /* ── Reduced motion ── */
    @media (prefers-reduced-motion: reduce) {
      html { scroll-behavior: auto; }
      .alinova-root *, .alinova-root *::before, .alinova-root *::after {
        animation-duration:        0.01ms !important;
        animation-iteration-count: 1      !important;
        transition-duration:       0.01ms !important;
        scroll-behavior:           auto   !important;
      }
      .reveal,
      .alinova-root section[id] { opacity: 1; transform: none; }
    }

    /* ── Scrollbar ── */
    .alinova-root ::-webkit-scrollbar       { width: 5px; }
    .alinova-root ::-webkit-scrollbar-track { background: ${DS.color.ink}; }
    .alinova-root ::-webkit-scrollbar-thumb {
      background: ${DS.color.aqua}; border-radius: 3px;
    }

    /* ── Responsive ── */
    @media (max-width: 1024px) {
      .nav-desktop    { display: none  !important; }
      .nav-mobile-btn { display: flex  !important; }
    }
    @media (max-width: 768px) {
      .col-2 { grid-template-columns: 1fr       !important; }
      .col-3 { grid-template-columns: 1fr       !important; }
      .col-4 { grid-template-columns: 1fr 1fr   !important; }
      .hide-m { display: none !important; }
      .hero-btns     { flex-direction: column !important; width: 100% !important; }
      .hero-btns > * { width: 100% !important; justify-content: center !important; }
    }
    @media (max-width: 480px) {
      .col-4    { grid-template-columns: 1fr !important; }
      .flex-col { flex-direction: column     !important; }
      .hero-object-shell  { max-width: 390px !important; }
      .hero-product-tag   { min-width: 0 !important; max-width: 148px; padding: 8px 10px !important; }
      .hero-product-tag-1 { top: 3%    !important; right: 0  !important; }
      .hero-product-tag-2 { bottom: 18% !important; left: 0  !important; }
      .hero-product-tag-3 { bottom: 1%  !important; right: 1% !important; }
    }
  `}</style>;